import "./about.scss";

declare var $: any;

$(document).ready(() => {
  // setupTeam();
  setupMentions();
});

/* Team
-------------------------------------------------------------------------*/

// const renderPerson = (name: string, title: string, image: string) => {
//   return `
//     <div class="person">
//       <div class="avatar" style="background-image: url('${image}')"></div>
//       <div class="texts">
//         <h4>${name}</h4>
//         <span>${title}</span>
//       </div>
//     </div>
//   `;
// };

// const renderTeam = (team: []) => {
//   const teamContainer = document.getElementById("people");
//   if (!teamContainer) {
//     return;
//   }

//   const peopleCode = team
//     .map((person) =>
//       renderPerson(
//         `${person["firstName"]} ${person["lastName"]}`,
//         person["title"],
//         person["photo"],
//       ),
//     )
//     .join("");

//   const teamCode = `
//     <div class="section">
//       <div class="persons">
//         ${peopleCode}
//       </div>
//     </div>
//   `;

//   teamContainer.innerHTML = teamCode;
// };

// const setupTeam = () => {
//   const loadTeam = () => {
//     const $teamContainer = $("#people");
//     $teamContainer.addClass("loading");

//     const url = "/about/team";
//     const promise = $.ajax({
//       url,
//       type: "GET",
//       dataType: "json",
//       contentType: "application/json",
//       data: "{}",
//     });

//     promise.done((resp: any) => {
//       $teamContainer.removeClass("loading");

//       const data = resp
//         .map((row: any) => ({
//           firstName: row.first_name,
//           lastName: row.last_name,
//           title: row.title,
//           photo: row.photo,
//         }))
//         .filter((person: any) => person.photo !== "");

//       renderTeam(data);
//     });
//   };

//   loadTeam();
// };

/* Mentions
-------------------------------------------------------------------------*/

const setupMentions = () => {
  const $articlesContainer = $("#articles");
  const $articles = $articlesContainer.find("ul.articles");
  const $pagination = $articlesContainer.find("ul.pagination");
  const isMobile = window.matchMedia("screen and (max-width: 600px)").matches;
  const pageSize = isMobile ? 5 : 10;
  let currentPage = 0;
  let totalPages = 0;
  let allMentions: {date: string; title: string; link: string; source: string}[] = [];

  const loadMentions = () => {
    $articlesContainer.addClass("loading");
    $articles.html("");
    $pagination.html("");

    const url = "/about/press-mentions";
    const promise = $.ajax({
      url,
      type: "GET",
      dataType: "json",
      contentType: "application/json",
      data: "{}",
    });

    promise.done((resp: any) => {
      $articlesContainer.removeClass("loading");

      const mentions: {date: string; title: string; link: string; source: string}[] = resp;
      const countLabel = $("#articles-count-label");
      const mentionsCount = mentions.length;
      countLabel.html(`${mentionsCount}+ times `);

      allMentions = mentions;
      totalPages = Math.ceil(mentionsCount / pageSize);

      renderCurrentPage();
    });
  };

  const getPaginationStartEnd = (currentPage: number, totalPages: number) => {
    if (currentPage < 2) {
      return {
        startAt: 0,
        endAt: 2,
      };
    } else {
      return {
        startAt: Math.max(0, currentPage - 1),
        endAt: Math.min(currentPage + 1, totalPages - 1),
      };
    }
  };

  const renderCurrentPage = () => {
    const items = allMentions.slice(currentPage * pageSize, currentPage * pageSize + pageSize);

    const html = items
      .map((row) => {
        return `<li>
        <div class="date-column">${row.date}</div>
        <div class="title-column">
          <a target="_blank" href="${row.link}">${row.title}</a>
          <span class="source">
            by <a target="_blank" href="${row.link}">${row.source}</a>
          </span>
        </div>
      </li>`;
      })
      .join("");
    $articles.html(html);

    const {startAt, endAt} = getPaginationStartEnd(currentPage, totalPages);
    const shouldShowFirst = currentPage > 1;
    const shouldShowLast = totalPages - currentPage > 2;

    let pagination = "";

    if (currentPage !== 0) {
      pagination += `<li class="arrow arrow-left"><a href="#" data-page="${
        currentPage - 1
      }"></a></li>`;
    }

    if (shouldShowFirst) {
      pagination += `<li><a href="#" data-page="0">1</a></li>`;
      pagination += `<li class="dots">...</li>`;
    }

    for (let i = startAt; i <= endAt; i++) {
      const isActive = i === currentPage;
      const className = isActive ? "active" : "";
      pagination += `<li class="${className}"><a href="#" data-page="${i}">${i + 1}</a></li>`;
    }

    if (shouldShowLast) {
      pagination += `<li class="dots">...</li>`;
      pagination += `<li><a href="#" data-page="${totalPages - 1}">${totalPages}</a></li>`;
    }

    if (currentPage !== totalPages - 1) {
      pagination += `<li class="arrow arrow-right"><a href="#" data-page="${
        currentPage + 1
      }"></a></li>`;
    }

    $pagination.html(pagination);
  };

  loadMentions();

  $pagination.on("click", "a", function (ev: any) {
    ev.preventDefault();
    const page = $(this).attr("data-page");
    currentPage = parseInt(page, 10);
    renderCurrentPage();
  });
};
